import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import React from 'react'

import Field from '../../../../../../components/Form/Field'

import { BUDGET_DAILY, BUDGET_LIFETIME } from '../../../../../Multiplatform/CampaignForms/fields'
import { selectedGoogleAdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

const FacebookCampaignBudgetFields = ({ budgetType, formik }) => {
  const { t } = useTranslation()

  const { currency_symbol: currencySymbol } = useSelector(selectedGoogleAdAccountSelector)

  return (
    <>
      {budgetType === BUDGET_LIFETIME && (
        <>
          <p>{t('A total budget for the whole campaign.')}</p>
          <p>{t('Facebook will allocate your budget across all your Ad Sets based on performance.')}</p>
          <Field
            type="number"
            formik={formik}
            name={BUDGET_LIFETIME}
            placeholder={t('Lifetime Budget')}
            symbol={currencySymbol}
            autoComplete="off"
          />
        </>
      )}
      {budgetType === BUDGET_DAILY && (
        <>
          <p>{t('Set an average amount you want to spend each day.')}</p>
          <p>
            {t(
              'Some functions (such as targeting ads during specific times of day) aren’t available if you select this option, so we don’t usually recommend it.'
            )}
          </p>
          <Field
            type="number"
            formik={formik}
            name={BUDGET_DAILY}
            placeholder={t('Daily Budget')}
            symbol={currencySymbol}
            autoComplete="off"
          />
        </>
      )}
    </>
  )
}

export default FacebookCampaignBudgetFields
